import { Button } from "@workspace/ui/components";
import { ArrowLeft } from "lucide-react";
import Link from "next/link";
import Image from "next/image";
import { ReactNode } from "react";

export const MobileHeader = ({
  returnPath,
  action,
}: {
  returnPath?: string;
  action?: ReactNode;
}) => {
  return (
    <div className="md:hidden fixed top-0 left-0 right-0 z-10 pt-[21px] pb-[20px] px-[20px] bg-[#f3e4c9]">
      <div className="flex items-center justify-between">
        {returnPath && (
          <Button variant="d-default" asChild className="size-10 p-1.5">
            <Link href={returnPath || "/"}>
              <ArrowLeft size={20} className="text-[#292524]" />
            </Link>
          </Button>
        )}
        <Image
          src="/logo.svg"
          alt="Yolk"
          width={113}
          height={40}
          className="h-[40px] w-[113.333px]"
        />
        {action || (
          <Button variant="d-default" className="size-10 p-1.5">
            <Image src="/icons/dots.svg" width={20} height={20} alt="dots" />
          </Button>
        )}
      </div>
    </div>
  );
};
